/* eslint-disable react/prop-types */ import React from "react";
import Style from "./Terminal.module.scss";
import classNames from "classnames";
import { Box } from "@mui/material";
const iconClass = "fa fa-circle";
function Terminal(props) {
  const { text } = props;
  return (
    <Box
      component={"section"}
      className={classNames(Style.terminal, Style.shadowed)}
      width={{ xs: "95%", sm: "90%", md: "80%", lg: "70%", xl: "60%" }}
      borderRadius={"0.5rem"}
      mb={{ xs: "2rem", md: "4rem" }}
      maxWidth={"100%"}
      overflow={"hidden"}
    >
      {" "}
      <Box
        sx={{ backgroundColor: "#8c8c8c" }}
        p={{ xs: "0.4rem 0.8rem", md: "0.5rem 1rem" }}
        borderRadius={"0.5rem 0.5rem 0 0"}
        fontSize={{ xs: "0.8rem", md: "1rem" }}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"flex-start"}
        gap={{ xs: "0.4rem", md: "0.6rem" }}
        minHeight={{ xs: "2rem", md: "2.5rem" }}
      >
        <Box
          component="i"
          className={classNames(iconClass, Style.red)}
          sx={{
            fontSize: { xs: "0.7rem", md: "0.9rem" },
            lineHeight: 1,
            display: "inline-block",
          }}
        />
        <Box
          component="i"
          className={classNames(iconClass, Style.amber)}
          sx={{
            fontSize: { xs: "0.7rem", md: "0.9rem" },
            lineHeight: 1,
            display: "inline-block",
          }}
        />
        <Box
          component="i"
          className={classNames(iconClass, Style.green)}
          sx={{
            fontSize: { xs: "0.7rem", md: "0.9rem" },
            lineHeight: 1,
            display: "inline-block",
          }}
        />
      </Box>
      <Box
        py={{ xs: "1rem", md: "2rem" }}
        px={{ xs: "1rem", md: "3rem" }}
        borderRadius={"0 0 0.5rem 0.5rem"}
        sx={{ backgroundColor: "#27242f", overflowX: "auto" }}
        fontSize={{ xs: "0.8rem", sm: "0.9rem", md: "1rem", lg: "1.1rem" }}
        fontFamily={"JetBrains Mono"}
      >
        {" "}
        {text}{" "}
      </Box>{" "}
    </Box>
  );
}
export default Terminal;
